const sanitizeURL = (url: string) => {
  const cleanedURL = decodeURI(url)
    .replaceAll(' ', '-') // Replace spaces with hyphens
    .replaceAll('.', '') // Remove periods
    .replaceAll(',', ''); // Remove commas

  // Remove special characters specific to Next.js reserved segments
  // Matches `[` `]` `(` `)`
  return cleanedURL.replace(/[\[\]\(\)]/g, '');
};

export default sanitizeURL;
